import {
  type FunctionComponent,
  type ReactNode,
  useEffect,
  useEffectEvent,
  useState,
} from 'react';

import { Button, ThemeProvider } from '@dr.pogodin/react-utils';

import IconArrowLeft from 'assets/images/icon-arrow-left.svg';

import buttonTheme from './button.scss';

import './style.scss';

const MAX_NUM_PAGES = 5;

function noop() {
  // NOOP
}

type PropsT = {
  numPages: number;
  selectedPage: number;
  setSelectedPage?: (page: number) => void;
};

const Paginator: FunctionComponent<PropsT> = ({
  numPages,
  selectedPage,
  setSelectedPage,
}) => {
  const [firstPage, setFirstPage] = useState(0);

  const endPage = Math.min(numPages, firstPage + MAX_NUM_PAGES);

  const onSetSelectedPage = useEffectEvent(setSelectedPage ?? noop);

  useEffect(() => {
    // TODO: Refactor.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (selectedPage < firstPage) setFirstPage(selectedPage);
    else if (selectedPage >= endPage) {
      setFirstPage(Math.max(0, selectedPage - MAX_NUM_PAGES + 1));
      onSetSelectedPage(endPage - 1);
    }
  }, [firstPage, endPage, selectedPage]);

  const paginator: ReactNode[] = [];

  if (firstPage) {
    paginator.push(
      <Button
        key="left"
        onClick={() => {
          setSelectedPage?.(selectedPage - 1);
          if (selectedPage === firstPage) setFirstPage(firstPage - 1);
        }}
      >
        <IconArrowLeft />
      </Button>,
    );
  }

  for (let i = firstPage; i < endPage; ++i) {
    paginator.push(
      <Button
        disabled={i === selectedPage}
        key={`page/${i}`}
        onClick={() => {
          setSelectedPage?.(i);
        }}
      >
        {i + 1}
      </Button>,
    );
  }

  if (endPage < numPages) {
    paginator.push(
      <Button
        key="right"
        onClick={() => {
          setSelectedPage?.(selectedPage + 1);
          if (selectedPage === endPage - 1) setFirstPage(firstPage + 1);
        }}
      >
        <IconArrowLeft styleName="rotate180" />
      </Button>,
    );
  }

  return (
    <ThemeProvider themes={{ Button: buttonTheme }}>
      <div styleName="paginator">{paginator}</div>
    </ThemeProvider>
  );
};

export default Paginator;
